import { useLayoutEffect, useState } from 'react';
import './ChartAnswer.css';

interface ChartAnswerProps {
  answer: string;
  percentage: string;
  count?: number;
}

function ChartAnswer({ answer, percentage, count }: ChartAnswerProps) {
  const [width, setWidth] = useState('0%');
  const displayText = count !== undefined ? `${count} (${percentage})` : (percentage || "0%");

  useLayoutEffect(() => {
    // Reset to 0 first, then animate to target
    setWidth('0%');
    requestAnimationFrame(() => {
      setWidth(percentage);
    });
  }, [percentage]);

  return (
    <>
      <div className="chart__answer__text">
        {answer}
      </div>
      <div
        className="chart__bar"
        style={{ width }}
      />
      <div className="chart__perc">
        {displayText}
      </div>
    </>
  );
}

export default ChartAnswer;